// src/pages/purchase/history/purchaseHistoryFilters.ts

import { FilterConfig } from '../../../components/Tables/advancedRecord/FilterBar';
import { DropdownDTO } from '../../../types/common/DropdownDTO';

/**
 * Construye los filtros para el historial de compras
 */
export const getPurchaseHistoryFilters = (
  allowedDocumentTypes: DropdownDTO[],
  suppliersDropdown: DropdownDTO[]
): FilterConfig[] => {
  return [
    {
      name: 'documentType',
      label: 'Tipo de Documento',
      type: 'select',
      options: allowedDocumentTypes,
      colSpan: 2,
    },

    {
      name: 'documentNumber',
      label: 'Número de Documento',
      type: 'text',
      colSpan: 2,
    },

    {
      name: 'supplierId',
      label: 'Proveedor',
      type: 'searchSelect',
      options: suppliersDropdown,
      colSpan: 3,
    },

    {
      name: 'documentDate',
      label: 'Fecha de Documento',
      type: 'date',
      colSpan: 3,
    },

    {
      name: 'total',
      label: 'Total Compra',
      type: 'number',
      colSpan: 2,
    },
  ];
};